export default {
  // colorPrimary: "#126b34",
  colorPrimary: "#00b96b",
}
